import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'brandSearchPipe', pure: false, standalone: true })
export class BrandSearchPipe implements PipeTransform {
  transform(brands: any, args?: any): Array<any> {
    const searchText = new RegExp(args, 'ig');
    if (brands) {
      return brands.filter((brand: { BrandName: string }) => {
        return brand.BrandName && brand.BrandName.search(searchText) !== -1;
      });
    } else return brands;
  }
}
